import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "13.5",
      height: "13.5",
      x: "3.25",
      y: "3.25",
      stroke: "currentColor",
      "stroke-width": "1.5",
      rx: "3.75"
    }, null, -1)
  ]))]))
}
export default { render: render }